






























































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import AgencyWorkerBookingConfirmationFooterEdit from '@/components/Agencies/AgencyWorkerBookingConfirmationFooterEdit.vue'
import AgencyWorkerBookingConfirmationHeaderEdit from '@/components/Agencies/AgencyWorkerBookingConfirmationHeaderEdit.vue'
import AgencyGeneralHealthAndSafetyInformationEdit from '@/components/Agencies/AgencyGeneralHealthAndSafetyInformationEdit.vue'
import AgencyGeneralTrainingInformationEdit from '@/components/Agencies/AgencyGeneralTrainingInformationEdit.vue'
import AgencyWorkerDashboardFooterEdit from '@/components/Agencies/AgencyWorkerDashboardFooterEdit.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';


@Component({
	name: 'AppSettings',
  	components: { AgencyWorkerDashboardFooterEdit, AgencyWorkerBookingConfirmationFooterEdit, AgencyWorkerBookingConfirmationHeaderEdit, AgencyGeneralHealthAndSafetyInformationEdit, AgencyGeneralTrainingInformationEdit, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getAgency();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingAgency;
  	}

  	get agency() {
		return AgencySettingsModule.agency;
  	}
}
